import React from 'react';
import { Routes, Route } from 'react-router-dom';

import ROUTES from 'constants/routes';
import Layout from 'layouts/AuthLayout/AuthLayout';
import UnAuthLayout from 'layouts/UnAuthLayout/UnAuthLayout';
import TokenLogin from 'pages/TokenLogin/TokenLogin'
import LoginPage from 'pages/Login/Login';
import PasswordRecoveryPage from 'pages/PasswordRecovery/PasswordRecovery';
import ProfilePage from 'pages/Profile/Profile';
import ContractsPage from 'pages/Contracts/Contracts';
import OrdersPage from 'pages/Orders/Orders';
import { useState } from 'react';
import {CookieModal,hasConsent, acceptCookies} from 'pages/CookieModal/CookieModal';

const App: React.FC = () => {
  
  const [showCookies, setShowCookies] = useState(() => !hasConsent());

  const onAccept = () => {
    acceptCookies();
    setShowCookies(false);
  };

  return (
    <>
    <Routes>
      <Route path={ROUTES.LOGIN} element={<UnAuthLayout><LoginPage /></UnAuthLayout>} />
      <Route path={ROUTES.PASSWORD_RECOVERY} element={<UnAuthLayout><PasswordRecoveryPage /></UnAuthLayout>} />
      <Route path={ROUTES.TOKEN_LOGIN} element={<TokenLogin />} />
      <Route
        path="/*"
        element={(
          <Layout>
            <Routes>
              <Route path={ROUTES.HOME} element={<ProfilePage />} />
              <Route path={ROUTES.CONTRACTS} element={<ContractsPage />} />
              <Route path={ROUTES.ORDERS} element={<OrdersPage />} />
              <Route
                path="*"
                element={(<div>404</div>)}
              />
            </Routes>
          </Layout>
        )}
      />
    </Routes>
       {showCookies && <CookieModal onClick={onAccept} />}
    </>
  );
};

export default App;
